module.exports = __webpack_public_path__ + "static/media/gusset-box-dieline.3c7b6211.svg";